import React, { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";

const TaskList = () => {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("Default Template 1");

  const data = [
    {
      staffName: "Chandru V",
      id: 43,
      address: "WQVP+M8V, P",
      clientName: "purushothaman",
      clientPhone: "9994371361",
      remarks: "Meeting Done",
      attachment: "Download",
    },
  ];

  return (
    <Box sx={{ p: 3, backgroundColor: "#f8f9fa" }}>
      {/* Title */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 3,
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "#333" }}>
          Task List
        </Typography>
        <Box>
          <Button
            variant="contained"
            color="primary"
            startIcon={<DownloadIcon />}
            sx={{ mr: 2, backgroundColor: "#2196f3", "&:hover": { backgroundColor: "#1976d2" } }}
          >
            Download Report
          </Button>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<AddIcon />}
            sx={{ borderColor: "#2196f3", color: "#2196f3", "&:hover": { borderColor: "#1976d2", color: "#1976d2" } }}
          >
            Edit Template
          </Button>
        </Box>
      </Box>

      {/* Date Picker and Dropdown */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 2,
          mb: 3,
        }}
      >
        <TextField
          label="Date"
          type="date"
          value={selectedDate}
          onChange={(e) => setSelectedDate(e.target.value)}
          sx={{
            width: "200px",
            backgroundColor: "white",
            borderRadius: "5px",
            "& .MuiOutlinedInput-root": {
              border: "1px solid gray",
              "&:hover fieldset": { borderColor: "black" },
              "&.Mui-focused fieldset": { borderColor: "black" },
            },
            "& .MuiInputBase-input": {
              color: "black",
            },
            "& .MuiInputLabel-root": {
              color: "black",
            },
          }}
          InputLabelProps={{ shrink: true }}
        />
        <Select
          value={selectedTemplate}
          onChange={(e) => setSelectedTemplate(e.target.value)}
          displayEmpty
          sx={{
            width: "200px",
            backgroundColor: "white",
            borderRadius: "5px",
            "& .MuiOutlinedInput-root": {
              border: "1px solid gray",
              "&:hover fieldset": { borderColor: "black" },
              "&.Mui-focused fieldset": { borderColor: "black" },
            },
            "& .MuiSelect-select": {
              border: "1px solid gray",
              color: "black",
              "&:focus": {
                border: "1px solid black",
              },
            },
            "& .MuiInputLabel-root": { color: "black" },
          }}
        >
          <MenuItem value="Default Template 1">Default Template 1</MenuItem>
          <MenuItem value="Template 2">Template 2</MenuItem>
        </Select>
        
      </Box>

      {/* Data Table */}
      <TableContainer component={Paper} sx={{ backgroundColor: "white" }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Staff Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>ID</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Address</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Client Name</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Client Phone</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Remarks</TableCell>
              <TableCell sx={{ fontWeight: "bold", color: "black" }}>Attachment</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell sx={{ color: "black" }}>{row.staffName}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.id}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.address}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.clientName}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.clientPhone}</TableCell>
                <TableCell sx={{ color: "black" }}>{row.remarks}</TableCell>
                <TableCell sx={{ color: "black" }}>
                  <Button
                    variant="outlined"
                    startIcon={<DownloadIcon />}
                    sx={{ borderColor: "#2196f3", color: "#2196f3", "&:hover": { borderColor: "#1976d2", color: "#1976d2" } }}
                  >
                    {row.attachment}
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TaskList;
